export const splitFullName = (fullName: string | undefined) => {
  if (!fullName) return { firstName: "", lastName: "" };

  const [firstName, ...rest] = fullName.split(" ");
  const lastName = rest.length > 1 ? rest.pop()! : rest.join("");

  return { firstName: firstName.charAt(0), lastName };
};
